import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';

import CreateAutojoinDomainMutation from '../../mutations/create_autojoin_domain_mutation';
import UpdateAutojoinDomainMutation from '../../mutations/update_autojoin_domain_mutation';
import DeleteAutojoinDomainMutation from '../../mutations/delete_autojoin_domain_mutation';

import {getDefaultMediumCompanyLogo} from '../../components/default_avatars';
import UpdateCompanyMutation from '../../mutations/update_company_mutation.modern';
import DeleteDemoMutation from '../../mutations/delete_demo_mutation';
import {injectIntl, FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import {companyLogoSrc, currencies, isoCountries, timezones, BUTTON_STYLE, BUTTON_COLOR} from '../../constants';
import * as tracking from '../../tracking';
import InputField from '../../components/inputs/input_field';
import SelectInput from '../../components/inputs/select_input';
import DeleteDemoDataMutation from '../../mutations/delete_demo_data_mutation';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import UploadingOverlay from '../../forecast-app/shared/components/uploading-overlay/uploading_overlay';
import Util from '../../forecast-app/shared/util/util';
import {showModal, MODAL_TYPE} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import Warning from '../../components/warning';
import emailBlockedList from '../../emailBlockedList';
import ReactDOM from 'react-dom';
import HoursInput from '../../forecast-app/shared/components/inputs/hours-input/hours_input_view';
import TooltipContainer from '../../forecast-app/shared/components/tooltips/tooltip_container';
import InformationIcon from '../../images/information-icon';
import DemoLineItem from '../../components/demo_line_item';
import Dropdown from '../../forecast-app/shared/components/dropdowns/dropdown';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../forecast-app/shared/components/headers/top-header-bar/TopHeaderBar';

class settingsCompany extends Component {
	constructor(props) {
		super(props);

		const company = this.props.viewer.company;

		this.demoProgressCheckTimeout = 0;

		const working_hours =
			this.props.viewer.language === 'ENGLISH_US'
				? [company.sunday / 60, company.monday / 60, company.tuesday / 60, company.wednesday / 60, company.thursday / 60, company.friday / 60, company.saturday / 60]
				: [company.monday / 60, company.tuesday / 60, company.wednesday / 60, company.thursday / 60, company.friday / 60, company.saturday / 60, company.sunday / 60];

		this.state = {
			name: company.name,
			street: company.street || '',
			zip: company.zip || '',
			city: company.city || '',
			vatId: company.vatId || '',
			country: company.country,
			currency: company.currency,
			timezone: company.timezone,
			contactName: company.contactName,
			contactEmail: company.contactEmail,
			contactPhone: company.contactPhone,
			isUploadingLogo: false,
			companyTarget: company.companyTarget === null ? '' : company.companyTarget * 100,
			working_hours: working_hours,
			showOverlay: false,
			newDomainName: '',
			domainsInUpdate: [],
			isUsingSchedulingPlanMode: company.isUsingSchedulingPlanMode,
			isUsingProjectAllocation: company.isUsingProjectAllocation,
		};
		this.domainInputs = [];
	}

	componentDidMount() {
		document.title = 'Details - Account - Forecast';
		// Segment
		tracking.trackPage('settings-details');
	}

	showChangesSavedToast() {
		createToast({duration: 2000, message: this.props.intl.formatMessage({id: 'common.changes_saved'})});
	}

	handleClientChange(property, value) {
		this.setState({[property]: value});
	}

	handleCompanyTargetSave(property) {
		let modifiedPercentage = this.state[property];
		if (modifiedPercentage === '') {
			modifiedPercentage = null;
		} else if (modifiedPercentage > 100) {
			modifiedPercentage = 100;
		} else if (modifiedPercentage < 0) {
			modifiedPercentage = 0;
		}

		if (modifiedPercentage !== null) {
			modifiedPercentage = Math.round(modifiedPercentage);
		}

		if (modifiedPercentage / 100 !== this.props.viewer.company.companyTarget) {
			this.handleClientChange(property, modifiedPercentage);
			Util.CommitMutation(
				UpdateCompanyMutation,
				{
					id: this.props.viewer.company.id,
					[property]: modifiedPercentage === null ? null : modifiedPercentage / 100,
				},
				() => this.showChangesSavedToast()
			);
		}
	}
	handleClientSave(property) {
		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				id: this.props.viewer.company.id,
				[property]: this.state[property],
			},
			() => this.showChangesSavedToast()
		);
	}

	handleChangeCountry(selection) {
		const country = selection ? selection.value : null;
		this.setState({country});
		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				id: this.props.viewer.company.id,
				country,
			},
			() => this.showChangesSavedToast()
		);
	}

	handleLogoChange() {
		const {formatMessage} = this.props.intl;
		const file = this.file_input.files[0];

		const onSuccess = () => {
			this.showChangesSavedToast();
			this.setState({isUploadingLogo: false});
		};

		Util.confirmFilePreviewType(file, res => {
			if (res) {
				this.setState({isUploadingLogo: true});
				Util.CommitMutation(UpdateCompanyMutation, {id: this.props.viewer.company.id}, onSuccess, true, false, {
					id: this.props.viewer.company.id,
					file: file,
				});
			} else if (!this.state.isUploadingLogo && !res) {
				showModal({
					type: MODAL_TYPE.GENERIC,
					content: (
						<div className="default-warning-modal">
							<Warning messageId="warning_modal.profile_picture_wrong_format_title" />
							<div className="warning-part-2">{formatMessage({id: 'warning_modal.profile_picture_wrong_format_info'})}</div>
						</div>
					),
					buttons: [
						{
							text: formatMessage({id: 'common.cancel'}),
							style: BUTTON_STYLE.FILLED,
							color: BUTTON_COLOR.WHITE,
						},
					],
				});
			}
		});
	}

	handleRemoveLogo() {
		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				id: this.props.viewer.company.id,
				logoId: 'delete',
			},
			() => this.showChangesSavedToast()
		);
	}

	handleChangeCurrency(selected) {
		if (selected.value === undefined) return;
		const onSuccess = result => {
			this.showChangesSavedToast();
			this.setState({currency: result.updateCompany.company.currency});
		};
		const update = () => {
			Util.CommitMutation(
				UpdateCompanyMutation,
				{
					id: this.props.viewer.company.id,
					currency: selected.value,
				},
				onSuccess
			);
		};
		//if there are exchange rates show warning modal first with cancel and continue options.
		if (this.props.viewer.company.exchangeRates.edges.length !== 0) {
			const {formatMessage} = this.props.intl;
			showModal({
				type: MODAL_TYPE.GENERIC,
				content: (
					<div className="default-warning-modal">
						<Warning messageId={'warning-modal.edit-warning-title'} useInfoIcon={true} />
						<div className="warning-part-2">{formatMessage({id: 'settings_details.currency_change_warning_exchange_rates'})}</div>
					</div>
				),
				buttons: [
					{
						text: formatMessage({id: 'common.cancel'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.WHITE,
					},
					{
						text: formatMessage({id: 'common.continue'}),
						style: BUTTON_STYLE.FILLED,
						color: BUTTON_COLOR.GREEN,
						callback: update,
					},
				],
			});
		} else {
			update();
		}
	}

	handleChangeTimezone(selected) {
		if (selected.value === undefined) return;
		const onSuccess = result => {
			this.showChangesSavedToast();
			this.setState({timezone: result.updateCompany.company.timezone});
		};
		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				id: this.props.viewer.company.id,
				timezone: selected.value,
			},
			onSuccess
		);
	}

	handleSchedulingModeChange() {
		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				id: this.props.viewer.company.id,
				isUsingSchedulingPlanMode: !this.state.isUsingSchedulingPlanMode,
			},
			() => this.showChangesSavedToast()
		);
		this.setState({isUsingSchedulingPlanMode: !this.state.isUsingSchedulingPlanMode});
	}

	handleAllocationModeChange(isUsingProjectAllocation) {
		showModal({
			type: MODAL_TYPE.CHANGE_ALLOCATION_TYPE,
			companyId: this.props.viewer.company.id,
			isUsingProjectAllocation: isUsingProjectAllocation,
			viewerId: this.props.viewer.id,
			changeAllocationOption: this.onChangeAllocation.bind(this),
		});
	}

	onChangeAllocation(isUsingProjectAllocation) {
		this.setState({
			isUsingProjectAllocation: isUsingProjectAllocation,
		});
	}

	saveWorkingHours(i, e) {
		const newHours = this.state.working_hours.slice();
		if (newHours[i] === e) return; //Don't trigger if the value did not change
		newHours[i] = e == null ? 0 : e;

		const validateHours = val => {
			if (isNaN(val)) return false;
			if (parseFloat(val) < -600000) return false;
			else if (parseFloat(val) > 600000) return false;
			return true;
		};
		let monday, tuesday, wednesday, thursday, friday, saturday, sunday;
		if (this.props.viewer.language === 'ENGLISH_US') {
			sunday = newHours[0];
			monday = newHours[1];
			tuesday = newHours[2];
			wednesday = newHours[3];
			thursday = newHours[4];
			friday = newHours[5];
			saturday = newHours[6];
		} else {
			monday = newHours[0];
			tuesday = newHours[1];
			wednesday = newHours[2];
			thursday = newHours[3];
			friday = newHours[4];
			saturday = newHours[5];
			sunday = newHours[6];
		}
		let isValid = true;
		[monday, tuesday, wednesday, thursday, friday, saturday, sunday].forEach((val, index) => {
			if (!validateHours(val)) {
				isValid = false;
				return;
			}
		});
		if (!isValid) return;
		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				id: this.props.viewer.company.id,
				monday: Math.round(monday * 60),
				tuesday: Math.round(tuesday * 60),
				wednesday: Math.round(wednesday * 60),
				thursday: Math.round(thursday * 60),
				friday: Math.round(friday * 60),
				saturday: Math.round(saturday * 60),
				sunday: Math.round(sunday * 60),
			},
			() => this.showChangesSavedToast()
		);
		this.setState({working_hours: newHours});
	}

	handleNewDomainNameChange(e) {
		this.setState({newDomainName: e.target.value});
	}

	handleAddDomain() {
		if (!this.state.newDomainName) return;
		const onSuccess = res => {
			if (res.createAutojoinDomain.autojoinDomain) {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'settings_details.domain_created'})});
			} else {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'settings_details.domain_taken'})});
			}
		};
		if (emailBlockedList.emailBlockedList.includes(this.state.newDomainName)) {
			createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'settings_details.domain_is_blocked'})});
			this.setState({newDomainName: ''});
		} else {
			Util.CommitMutation(
				CreateAutojoinDomainMutation,
				{
					companyId: this.props.viewer.company.id,
					name: this.state.newDomainName,
				},
				onSuccess
			);
		}

		this.setState({newDomainName: ''});
	}

	handleDeleteDomain(domainId) {
		// confirmation window
		const onSuccess = test => {
			createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'settings_details.domain_deleted'})});
		};
		const callbackPositive = params => {
			Util.CommitMutation(
				DeleteAutojoinDomainMutation,
				{
					companyId: this.props.viewer.company.id,
					id: domainId,
				},
				onSuccess
			);
		};
		showModal({
			type: MODAL_TYPE.GENERIC_DELETION_WARNING,
			deleteCallback: callbackPositive,
		});
	}

	handleDomainNameBlur(domainId, inputIndex, e) {
		var domainBeforeUpdateAttempt = this.state.domainsInUpdate.filter(obj => {
			return obj.id === domainId;
		});
		const onSuccess = res => {
			if (res.updateAutojoinDomain.AutojoinDomain) {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'settings_details.domain_updated'})});
			} else {
				const domNode = ReactDOM.findDOMNode(this.domainInputs[inputIndex]);
				domNode.value = domainBeforeUpdateAttempt[0].name;
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'settings_details.domain_taken'})});
			}
			let domainsInUpdate = [...this.state.domainsInUpdate];
			let index = domainsInUpdate.findIndex(domain => domain.id === domainId);
			if (index !== -1) {
				domainsInUpdate.splice(index, 1);
				this.setState({domainsInUpdate: domainsInUpdate});
			}
		};

		if (emailBlockedList.emailBlockedList.includes(e.target.value)) {
			const domNode = ReactDOM.findDOMNode(this.domainInputs[inputIndex]);
			domNode.value = domainBeforeUpdateAttempt[0].name;
			createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'settings_details.domain_is_blocked'})});
			this.setState({newDomainName: ''});
		} else {
			Util.CommitMutation(
				UpdateAutojoinDomainMutation,
				{
					id: domainId,
					name: e.target.value,
				},
				onSuccess
			);
		}
	}

	handleDomainNameFocus(e) {
		let domainUpdate = {id: e.target.id, name: e.target.value};
		const newDomainUpdate = [...this.state.domainsInUpdate, domainUpdate];
		this.setState({domainsInUpdate: newDomainUpdate});
	}

	handleKeyPressDomain(index, e) {
		if (e.key === 'Enter') {
			this.domainInputs[index].blur();
		}
	}

	createTrialData() {
		return false;
	}

	createDemoData() {
		showModal({
			type: MODAL_TYPE.SAVE_DEMO_ENVIRONMENT,
			companyId: this.props.viewer.company.id,
		});
	}

	deleteDemoData() {
		const onSuccess = () => {
			this.setState({showOverlay: false});
			createToast({
				duration: 5000,
				message: this.props.intl.formatMessage({id: 'settings_details.demo_data_deleted'}),
			});
		};
		this.setState({showOverlay: true});

		Util.CommitMutation(
			DeleteDemoDataMutation,
			{
				companyId: this.props.viewer.company.id,
			},
			onSuccess
		);
	}

	deleteDemoEnvironment(demo) {
		const {formatMessage} = this.props.intl;

		const onSuccess = () => {
			this.setState({showOverlay: false});
			createToast({
				duration: 5000,
				message: formatMessage({id: 'settings_details.demo_deleted_toast'}),
			});
		};
		const callbackPositive = () => {
			this.setState({showOverlay: true});
			Util.CommitMutation(
				DeleteDemoMutation,
				{
					companyId: this.props.viewer.company.id,
					id: demo.id,
				},
				onSuccess
			);
		};

		showModal({
			type: MODAL_TYPE.GENERIC,
			content: (
				<div className="default-warning-modal">
					<Warning messageId="settings_details.delete_demo_environment" />
					<div className="warning-part-2">{formatMessage({id: 'settings_details.delete_demo_info'})}</div>
				</div>
			),
			buttons: [
				{
					text: formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
				{
					text: formatMessage({id: 'common.delete'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.GREEN,
					callback: callbackPositive,
				},
			],
		});
	}

	intervalProgressCheck() {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		const init = {headers: headers, credentials: 'include'};

		fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'demo_projects_progress', init)
			.then(result => result.json())
			.then(res => {
				this.setState({snapshotProjectsRemaining: res.projects});

				if (res.projects === 0) {
					clearInterval(this.demoProgressCheckTimeout);
					this.setState({showOverlay: false});
					createToast({
						duration: 5000,
						message: this.props.intl.formatMessage({id: 'settings_details.demo_generated_toast'}),
					});
				} else if (res.projects === -1) {
					clearInterval(this.demoProgressCheckTimeout);
					this.setState({showOverlay: false});
					showModal({
						type: MODAL_TYPE.GENERIC,
						content: (
							<div className="default-warning-modal">
								<div className="warning-part-2">{this.props.intl.formatMessage({id: 'settings_details.demo_generated_error_toast'}) + '. CorrelationId: ' + res.correlationId}</div>
							</div>
						),
						buttons: [
							{
								text: 'OK',
								style: BUTTON_STYLE.FILLED,
								color: BUTTON_COLOR.WHITE,
							},
						],
					});
				} else {
					if (res.projects === 1) {
						createToast({
							duration: 5000,
							message: `Restoring generic data`,
						});
					} else {
						createToast({
							duration: 5000,
							message: `Progress (${res.projects} project(s) remainig out of ${this.state.snapshotProjectsTotal})`,
						});
					}
				}
			});
	}

	generateDemoEnvironment(demo) {
		const {formatMessage} = this.props.intl;
		const callbackPositive = () => {
			const headers = new Headers();
			headers.append('Content-Type', 'application/json');
			const init = {headers: headers, credentials: 'include'};
			const demoId = demo.id;
			this.setState({showOverlay: true, snapshotProjectsTotal: demo.numberOfProjects, snapshotProjectsRemaining: demo.numberOfProjects});
			fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + `activate_demo?demoId=${demoId}`, init);
			this.demoProgressCheckTimeout = setInterval(this.intervalProgressCheck.bind(this), 3000);
		};

		showModal({
			type: MODAL_TYPE.GENERIC,
			content: (
				<div className="default-warning-modal">
					<Warning messageId="settings_details.generate_demo_environment" />
					<div className="warning-part-2">{formatMessage({id: 'settings_details.generate_demo_info'})}</div>
					<div className="warning-part-2">{formatMessage({id: 'settings_details.generate_demo_info_2'})}</div>
				</div>
			),
			buttons: [
				{
					text: formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
					//callback: callbackNegative,
				},
				{
					text: formatMessage({id: 'common.generate'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.GREEN,
					callback: callbackPositive,
				},
			],
		});
	}

	handleContactPersonChange(selected) {
		Util.CommitMutation(
			UpdateCompanyMutation,
			{
				id: this.props.viewer.company.id,
				contactPersonId: selected.value,
			},
			() => this.showChangesSavedToast()
		);
	}

	getHeader() {
		return (
			<TopHeaderBarWrapper>
				<TopHeaderBar title={this.props.intl.formatMessage({id: 'common.details'})} />
			</TopHeaderBarWrapper>
		);
	}

	render() {
		const domains = this.props.viewer.company.autojoinDomains.edges;
		const demos = this.props.viewer.company.demos.edges;

		const {formatMessage} = this.props.intl;
		const logoSrc = this.props.viewer.company.logoId !== null ? companyLogoSrc(this.props.viewer.company.logoId) : getDefaultMediumCompanyLogo(this.props.viewer.company.logoDefaultId);
		const weekdays =
			this.props.viewer.language === 'ENGLISH_US'
				? [
						formatMessage({id: 'common.sunday'}),
						formatMessage({id: 'common.monday'}),
						formatMessage({id: 'common.tuesday'}),
						formatMessage({id: 'common.wednesday'}),
						formatMessage({id: 'common.thursday'}),
						formatMessage({id: 'common.friday'}),
						formatMessage({id: 'common.saturday'}),
				  ]
				: [
						formatMessage({id: 'common.monday'}),
						formatMessage({id: 'common.tuesday'}),
						formatMessage({id: 'common.wednesday'}),
						formatMessage({id: 'common.thursday'}),
						formatMessage({id: 'common.friday'}),
						formatMessage({id: 'common.saturday'}),
						formatMessage({id: 'common.sunday'}),
				  ];

		const contactPerson = this.props.viewer.company.contactPerson;
		const personOptions = this.props.viewer.company.allPersons.edges
			.filter(person => person.node.email)
			.map(person => {
				return {value: person.node.id, label: person.node.fullName, profilePictureId: person.node.profilePictureId, firstName: person.node.firstName, lastName: person.node.lastName};
			})
			.sort((a, b) => a.label - b.label);

		return (
			<div className={'section-content settings-app settings-details'} data-cy="settings-details">
				{this.props.children}
				{this.state.showOverlay ? <UploadingOverlay /> : null}
				{this.getHeader()}
				<CustomScrollDiv>
					<div className={'section-body'}>
						<div className="inner">
							<fieldset className="company-logo">
								<h3>{formatMessage({id: 'settings_details.address_section'})}</h3>
								<p className="description">{formatMessage({id: 'settings_details.address_section_info'})}</p>
								<div className="details">
									<div className="titles-material">
										<InputField
											label={formatMessage({id: 'settings.client-company-name'})}
											type="text"
											placeholder={formatMessage({id: 'settings_details.company_name_placeholder'})}
											id="company_name"
											value={this.state.name}
											onChange={this.handleClientChange.bind(this, 'name')}
											onBlur={this.handleClientSave.bind(this, 'name')}
											blurOnEnter={true}
										/>
										<InputField
											label={formatMessage({id: 'settings.client-company-street'})}
											type="text"
											placeholder={formatMessage({id: 'settings_details.company_street_placeholder'})}
											id="company_street"
											value={this.state.street}
											onChange={this.handleClientChange.bind(this, 'street')}
											onBlur={this.handleClientSave.bind(this, 'street')}
											blurOnEnter={true}
										/>
										<InputField
											label={formatMessage({id: 'settings.client-company-zip'})}
											type="text"
											placeholder={formatMessage({id: 'settings_details.company_zip_placeholder'})}
											id="company_zip"
											value={this.state.zip}
											onChange={this.handleClientChange.bind(this, 'zip')}
											onBlur={this.handleClientSave.bind(this, 'zip')}
											blurOnEnter={true}
										/>
										<InputField
											label={formatMessage({id: 'settings.client-company-city'})}
											type="text"
											placeholder={formatMessage({id: 'settings_details.company_city_placeholder'})}
											id="company_city"
											value={this.state.city}
											onChange={this.handleClientChange.bind(this, 'city')}
											onBlur={this.handleClientSave.bind(this, 'city')}
											blurOnEnter={true}
										/>
										{/*<label htmlFor="company_country">
                                         <span>{formatMessage({id: 'settings.client-company-country'})}</span>
                                         <div className="select-wrapper">
                                         <Select
                                         placeholder={formatMessage({id: 'settings_details.company_country_placeholder'})}
                                         name="form-field-country"
                                         options={isoCountries}
                                         value={this.state.country}
                                         onChange={this.handleChangeCountry.bind(this)}
                                         matchProp="label"
                                         />
                                         </div>
                                         </label>*/}
										<SelectInput value={this.state.country} options={isoCountries} label={formatMessage({id: 'settings.client-company-country'})} onChange={this.handleChangeCountry.bind(this)} multi={false} clearable={true} />
										<InputField
											label={formatMessage({id: 'settings.client-company-vat'})}
											type="text"
											placeholder={formatMessage({id: 'settings_details.company_vat_placeholder'})}
											id="company_vat"
											value={this.state.vatId}
											onChange={this.handleClientChange.bind(this, 'vatId')}
											onBlur={this.handleClientSave.bind(this, 'vatId')}
											blurOnEnter={true}
										/>
									</div>
									<div className="logo">
										<div className={this.state.isUploadingLogo ? 'upload-overlay' : 'upload-overlay-hidden'}>
											<div className={this.props.isUploading ? 'uploading-gif' : 'uploading-gif-hidden'} />
										</div>
										<img crossOrigin="use-credentials" src={logoSrc} width="140" height="140" />
										<div className="controls">
											<div className="controls-update">
												<input
													id="file-input"
													type="file"
													onChange={this.handleLogoChange.bind(this)}
													ref={input => (this.file_input = input)}
													onClick={e => {
														e.target.value = null;
													}}
												/>
												<label className="control update">{formatMessage({id: 'settings_details.update-logo'})}</label>
											</div>
											{this.props.viewer.company.logoId ? (
												<div className="control remove" onClick={this.handleRemoveLogo.bind(this)}>
													{formatMessage({id: 'settings_details.remove-logo'})}
												</div>
											) : null}
										</div>
									</div>
								</div>
							</fieldset>
							<fieldset className="currency">
								<h3>{formatMessage({id: 'settings_details.currency_section'})}</h3>
								<div className="titles">
									<p className="description">{formatMessage({id: 'settings_details.currency_section_info'})}</p>
									<SelectInput
										placeholder={formatMessage({id: 'settings_details.currency_placeholder'})}
										options={currencies}
										value={this.state.currency}
										onChange={this.handleChangeCurrency.bind(this)}
										clearable={false}
										label={formatMessage({id: 'settings_details.currency_section'})}
										multi={false}
									/>
								</div>
							</fieldset>
							<fieldset className="working-hours">
								<h3>{formatMessage({id: 'settings_details.default-working-hours'})}</h3>
								<div className="titles">
									<p className="description">{formatMessage({id: 'settings_details.default-working-hours-description'})}</p>
									<table className="company-default-hours">
										<thead>
											<tr>
												{weekdays.map((day, index) => (
													<th key={index}>{day}</th>
												))}
											</tr>
										</thead>

										<tbody>
											<tr>
												{[...Array(7)].map((_, i) => (
													<td key={i} className="input-cell">
														<HoursInput value={this.state.working_hours[i]} nonWorkingDay={this.state.working_hours[i] === 0} mutation={this.saveWorkingHours.bind(this, i)} />
													</td>
												))}
											</tr>
										</tbody>
									</table>
								</div>
							</fieldset>
							<fieldset className="timezone">
								<h3>{formatMessage({id: 'settings_details.timezone'})}</h3>
								<div className="titles">
									<p className="description">{formatMessage({id: 'settings_details.timezone_section_info'})}</p>
									<SelectInput
										placeholder={formatMessage({id: 'settings_details.timezone_placeholder'})}
										options={timezones}
										value={this.state.timezone}
										onChange={this.handleChangeTimezone.bind(this)}
										clearable={false}
										label={formatMessage({id: 'settings_details.timezone'})}
										multi={false}
									/>
								</div>
							</fieldset>
							<fieldset id="resource-management" className="resource-management">
								<h3>{formatMessage({id: 'settings_details.resource_management'})}</h3>
								<div className="utilization-type-fields">
									<p className="description">{formatMessage({id: 'settings.adjust_billable_utilization_target'})}</p>
									<div style={{width: '170px'}} data-userpilot={'admin-company-target'}>
										<InputField
											label={formatMessage({id: 'settings.billable_utilization_target'})}
											type="number"
											placeholder={'80'}
											id="company_target"
											min={0}
											max={100}
											value={this.state.companyTarget}
											onChange={this.handleClientChange.bind(this, 'companyTarget')}
											onBlur={this.handleCompanyTargetSave.bind(this, 'companyTarget')}
											blurOnEnter={true}
											suffix="%"
										/>
									</div>
								</div>
								<div className="resource-management-fields">
									<p className="description">{formatMessage({id: 'settings_details.resource_management_section_info'})}</p>
									<label className="radio-button-container" htmlFor="projects">
										<input type="radio" name="resource-management-type" id="projects" checked={this.state.isUsingProjectAllocation === true} onChange={this.handleAllocationModeChange.bind(this, true)} />
										<FormattedHTMLMessage id="settings_details.project_allocation" />
										<TooltipContainer
											infoText={[
												{
													title: ['settings_details.project_allocation'],
													details: ['settings_details.project_allocation_tooltip_text'],
													noBox: true,
												},
											]}
											tooltipInfinteDuration={true}
											edgeOffset={350}
										>
											<InformationIcon />
										</TooltipContainer>
									</label>
									<label className="radio-button-container" htmlFor="tasks">
										<input type="radio" name="resource-management-type" id="tasks" checked={this.state.isUsingProjectAllocation === false} onChange={this.handleAllocationModeChange.bind(this, false)} />
										<FormattedHTMLMessage id="settings_details.task_allocation" />
										<TooltipContainer
											infoText={[
												{
													title: ['settings_details.task_allocation'],
													details: ['settings_details.task_allocation_tooltip_text'],
													noBox: true,
												},
											]}
											tooltipInfinteDuration={true}
											edgeOffset={350}
										>
											<InformationIcon />
										</TooltipContainer>
									</label>
								</div>

								{this.state.isUsingProjectAllocation === false ? (
									<div className="heatmap-type-fields sub-option-container">
										<label className="radio-button-container sub-option" htmlFor="planned">
											<input type="radio" name="heatmap-type" id="planned" checked={this.state.isUsingSchedulingPlanMode} onChange={this.handleSchedulingModeChange.bind(this)} />
											<FormattedHTMLMessage id="settings_details.heatmap_planned" />
											<TooltipContainer
												infoText={[
													{
														title: ['settings_details.heatmap_planned'],
														details: ['settings_details.heatmap_planned_tooltip_text'],
														noBox: true,
													},
												]}
												tooltipInfinteDuration={true}
												edgeOffset={350}
											>
												<InformationIcon />
											</TooltipContainer>
										</label>
										<label className="radio-button-container sub-option" htmlFor="actual">
											<input type="radio" name="heatmap-type" id="actual" checked={!this.state.isUsingSchedulingPlanMode} onChange={this.handleSchedulingModeChange.bind(this)} />
											<FormattedHTMLMessage id="settings_details.heatmap_actual" />
											<TooltipContainer
												infoText={[
													{
														title: ['settings_details.heatmap_actual'],
														details: ['settings_details.heatmap_actual_tooltip_text'],
														noBox: true,
													},
												]}
												tooltipInfinteDuration={true}
												edgeOffset={350}
											>
												<InformationIcon />
											</TooltipContainer>
										</label>
									</div>
								) : null}
							</fieldset>
							<fieldset className="general">
								<h3>{formatMessage({id: 'settings_details.contact_section'})}</h3>
								<p className="description">{formatMessage({id: 'settings_details.contact_section_info'})}</p>
								<div className="titles-material">
									{this.props.viewer.availableFeatureFlags.some(flag => flag.key === 'contact_dropdown') ? (
										<div style={{width: '260px'}}>
											<Dropdown
												options={personOptions}
												isPersonSelector={true}
												personImageSize={'24'}
												onChange={this.handleContactPersonChange.bind(this)}
												label={'Contact Person'}
												value={contactPerson ? contactPerson.id : null}
												maxHeight={300}
											/>
											<InputField label={formatMessage({id: 'settings_details.contact_person_email'})} type="text" id="company_contact_email" value={contactPerson ? contactPerson.email : null} locked={true} />
										</div>
									) : (
										<>
											<InputField
												label={formatMessage({id: 'settings_details.contact_person_name'})}
												type="text"
												placeholder={formatMessage({id: 'settings_details.contact_person_name_placeholder'})}
												id="company_contact_name"
												value={this.state.contactName}
												onChange={this.handleClientChange.bind(this, 'contactName')}
												onBlur={this.handleClientSave.bind(this, 'contactName')}
												blurOnEnter={true}
											/>
											<InputField
												label={formatMessage({id: 'settings_details.contact_person_email'})}
												type="text"
												placeholder={formatMessage({id: 'settings_details.contact_person_email_placeholder'})}
												id="company_contact_email"
												value={this.state.contactEmail}
												onChange={this.handleClientChange.bind(this, 'contactEmail')}
												onBlur={this.handleClientSave.bind(this, 'contactEmail')}
												blurOnEnter={true}
											/>
										</>
									)}
									<InputField
										label={formatMessage({id: 'settings_details.contact_person_phone'})}
										type="text"
										placeholder={formatMessage({id: 'settings_details.contact_person_phone_placeholder'})}
										id="company_contact_phone"
										value={this.state.contactPhone}
										onChange={this.handleClientChange.bind(this, 'contactPhone')}
										onBlur={this.handleClientSave.bind(this, 'contactPhone')}
										blurOnEnter={true}
									/>
								</div>
							</fieldset>
							<fieldset>
								<h3>{formatMessage({id: 'settings_details.domains-list-title'})}</h3>
								<p className="description">{formatMessage({id: 'settings_details.sub-title'})}</p>
								<table>
									<thead>
										<tr>
											<th>{formatMessage({id: 'settings_details.add-domain-here'})}</th>
											<th>&nbsp;</th>
										</tr>
									</thead>
									<tbody>
										{domains.map((domain, index) => (
											<tr key={domain.node.id}>
												<td>
													<input
														ref={input => (this.domainInputs[index] = input)}
														type="text"
														id={domain.node.id}
														defaultValue={domain.node.name}
														placeholder={formatMessage({id: 'settings_details.domain'})}
														onBlur={this.handleDomainNameBlur.bind(this, domain.node.id, index)}
														onKeyPress={e => this.handleKeyPressDomain(index, e)}
														onFocus={this.handleDomainNameFocus.bind(this)}
													/>
												</td>
												<td className="controls">
													<span onClick={this.handleDeleteDomain.bind(this, domain.node.id)} className="remove">
														{formatMessage({id: 'common.delete'})}
													</span>
												</td>
											</tr>
										))}
										<tr>
											<td>
												<InputField
													type="text"
													value={this.state.newDomainName}
													onChange={this.handleClientChange.bind(this, 'newDomainName')}
													placeholder={formatMessage({id: 'settings_details.domain'})}
													blurOnEnter={true}
													onBlur={this.handleAddDomain.bind(this)}
												/>
											</td>
											<td>&nbsp;</td>
											<td>
												<button className="submit-button" onClick={this.handleAddDomain.bind(this)}>
													{formatMessage({id: 'settings_details.add_domain'})}
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</fieldset>
							{!this.props.viewer.company.forecastDemo && this.props.viewer.company.hasDemoData ? (
								<fieldset className="demo-data">
									<h3>{formatMessage({id: 'settings_details.demo_data'})}</h3>
									<div>
										<button className="delete-project-button" onClick={this.deleteDemoData.bind(this)}>
											<FormattedMessage id="settings_details.delete_all_demo_data" />
										</button>
									</div>
								</fieldset>
							) : this.props.viewer.company.forecastDemo ? (
								<fieldset className="demo-data">
									<h3>{formatMessage({id: 'settings_details.demo_data'})}</h3>
									<div>
										<button onClick={this.createTrialData.bind(this)} disabled={true}>
											Create demo
										</button>
										This way of generating demos has been deprecated. If you absolutely need this, contact Lukas (or try loading up one of the saved demo environments instead)
									</div>
									<div>
										<div>
											<button onClick={this.createDemoData.bind(this)}>{formatMessage({id: 'settings_details.save_demo_environment'})}</button>
										</div>

										{this.props.viewer.company.hasDemoData ? (
											<div>
												<button className="delete-project-button" onClick={this.deleteDemoData.bind(this)}>
													<FormattedMessage id="settings_details.delete_all_demo_data" />
												</button>
											</div>
										) : null}
										<div className="demo-table-wrapper">
											<table>
												<thead>
													<tr>
														<th className="column-name">{formatMessage({id: 'settings_details.demo_environment'})}</th>
														<th className="column-name">{formatMessage({id: 'settings_details.demo_created_by'})}</th>
														<th className="column-name">Projects</th>
													</tr>
												</thead>

												<tbody>
													{demos.map(demo => {
														return (
															<DemoLineItem
																key={demo.node.id}
																demo={demo.node}
																viewerEmail={this.props.viewer.email}
																onSelect={this.generateDemoEnvironment.bind(this, demo.node)}
																onDelete={this.deleteDemoEnvironment.bind(this, demo.node)}
															/>
														);
													})}
												</tbody>
											</table>
										</div>
									</div>
								</fieldset>
							) : null}
						</div>
					</div>
				</CustomScrollDiv>
			</div>
		);
	}
}

const settingsCompanyQuery = graphql`
	query settingsCompany_Query {
		viewer {
			actualPersonId
			component(name: "settings_company")
			...settingsCompany_viewer
		}
	}
`;

export {settingsCompanyQuery};

export default injectIntl(
	createFragmentContainer(settingsCompany, {
		viewer: graphql`
			fragment settingsCompany_viewer on Viewer {
				id
				language
				email
				availableFeatureFlags {
					key
				}
				company {
					id
					name
					backendId
					currency
					timezone
					logoId
					logoDefaultId
					companyTarget
					monday
					tuesday
					wednesday
					thursday
					friday
					saturday
					sunday
					street
					zip
					city
					country
					vatId
					contactPerson {
						id
						fullName
						email
					}
					contactName
					contactEmail
					contactPhone
					isUsingSchedulingPlanMode
					isUsingProjectAllocation
					forecastDemo
					hasDemoData
					modules {
						moduleType
					}
					allPersons(first: 100000, onlyActive: true, excludeClientUsers: true) {
						edges {
							node {
								id
								fullName
								firstName
								lastName
								email
								profilePictureId
							}
						}
					}
					autojoinDomains(first: 10000) @connection(key: "Company_autojoinDomains") {
						edges {
							node {
								id
								name
							}
						}
					}
					demos(first: 10000) @connection(key: "Company_demos") {
						edges {
							node {
								id
								name
								trialDemo
								sharedInCompany
								createdByEmail
								numberOfProjects
							}
						}
					}
					exchangeRates(first: 10000) {
						edges {
							node {
								id
							}
						}
					}
				}
				availableFeatureFlags {
					key
				}
			}
		`,
	})
);
